export enum SelectListItemStateType {
	ENABLED = 'enabled',
	SELECTED = 'selected',
	DISABLED = 'disabled',
}